import React from "react";
import EnzoFiol from "../../assets/CvMkpViki.pdf";

const CTA = () => {
  return (
    <div className="cta">
      <a href={EnzoFiol} download className="btn">
        Mi CV
      </a>
      <a href="#contact" className="btn btn-primary">
        ¡Contactame!
      </a>
    </div>
  );
};

export default CTA;
